module.exports = __webpack_public_path__ + "img/make-payment.8f8156be.png";